import { marker } from "@jsverse/transloco-keys-manager/marker";
import { sntTranslate } from "src/app/support/translate";

export enum VatNatureType {
  N1 = "N1", // Escluse ex. art. 15 del D.P.R. 633/1972
  N2 = "N2", // Non soggette
  N2_1 = "N2.1", // Non soggette ad IVA ai sensi degli artt. da 7 a 7-septies del DPR 633/72
  N2_2 = "N2.2", // Non soggette - altri casi
  N3 = "N3", // Non imponibili
  N3_1 = "N3.1", // Non Imponibili - esportazioni
  N3_2 = "N3.2", // Non Imponibili - cessioni intracomunitarie
  N3_3 = "N3.3", // Non Imponibili - cessioni verso San Marino
  N3_4 = "N3.4", // Non Imponibili - operazioni assimilate alle cessioni all'esportazione
  N3_5 = "N3.5", // Non Imponibili - a seguito di dichiarazioni d'intento
  N3_6 = "N3.6", // Non Imponibili - altre operazioni che non concorrono alla formazione del plafond
  N4 = "N4", // Esenti
  N5 = "N5", // Regime del margine/IVA non esposta in fattura
  N6 = "N6", // Inversione contabile (per le operazioni in reverse charge ovvero nei casi di autofatturazione per acquisti extra UE di servizi ovvero per importazioni di beni nei soli casi previsti)
  N6_1 = "N6.1", // Inversione contabile - cessione di rottami e altri materiali di recupero
  N6_2 = "N6.2", // Inversione contabile - cessione di oro e argento ai sensi della legge 7/2000 nonché di oreficeria usata ad OPO
  N6_3 = "N6.3", // Inversione contabile - subappalto nel settore edile
  N6_4 = "N6.4", // Inversione contabile - cessione di fabbricati
  N6_5 = "N6.5", // Inversione contabile - cessione di telefoni cellulari
  N6_6 = "N6.6", // Inversione contabile - cessione di prodotti elettronici
  N6_7 = "N6.7", // Inversione contabile - prestazioni comparto edile e settori connessi
  N6_8 = "N6.8", // Inversione contabile - operazioni settore energetico
  N6_9 = "N6.9", // Inversione contabile - altri casi
  N7 = "N7" // IVA assolta in altro stato UE (prestazione di servizi di telecomunicazioni, tele-radiodiffusione ed elettronici ex art. 7-octies lett. a, b, art. 74-sexies DPR 633/72)
}

export const VatNatureTypeDescriptionsFactory: () => Record<
  VatNatureType,
  string
> = () => {
  return <Record<VatNatureType, string>>{
    [VatNatureType.N1]: sntTranslate(
      marker("Escluse ex. art. 15 del D.P.R. 633/1972")
    ),
    [VatNatureType.N2]: sntTranslate(marker("Non soggette")),
    [VatNatureType.N2_1]: sntTranslate(
      marker(
        "Non soggette ad IVA ai sensi degli artt. da 7 a 7-septies del DPR 633/72"
      )
    ),
    [VatNatureType.N2_2]: sntTranslate(marker("Non soggette - altri casi")),
    [VatNatureType.N3]: sntTranslate(marker("Non imponibili")),
    [VatNatureType.N3_1]: sntTranslate(marker("Non Imponibili - esportazioni")),
    [VatNatureType.N3_2]: sntTranslate(
      marker("Non Imponibili - cessioni intracomunitarie")
    ),
    [VatNatureType.N3_3]: sntTranslate(
      marker("Non Imponibili - cessioni verso San Marino")
    ),
    [VatNatureType.N3_4]: sntTranslate(
      marker(
        "Non Imponibili - operazioni assimilate alle cessioni all'esportazione"
      )
    ),
    [VatNatureType.N3_5]: sntTranslate(
      marker("Non Imponibili - a seguito di dichiarazioni d'intento")
    ),
    [VatNatureType.N3_6]: sntTranslate(
      marker(
        "Non Imponibili - altre operazioni che non concorrono alla formazione del plafond"
      )
    ),
    [VatNatureType.N4]: sntTranslate(marker("Esenti")),
    [VatNatureType.N5]: sntTranslate(
      marker("Regime del margine/IVA non esposta in fattura")
    ),
    [VatNatureType.N6]: sntTranslate(marker("Inversione contabile")),
    [VatNatureType.N6_1]: sntTranslate(
      marker(
        "Inversione contabile - cessione di rottami e altri materiali di recupero"
      )
    ),
    [VatNatureType.N6_2]: sntTranslate(
      marker(
        "Inversione contabile - cessione di oro e argento ai sensi della legge 7/2000 nonché di oreficeria usata ad OPO"
      )
    ),
    [VatNatureType.N6_3]: sntTranslate(
      marker("Inversione contabile - subappalto nel settore edile")
    ),
    [VatNatureType.N6_4]: sntTranslate(
      marker("Inversione contabile - cessione di fabbricati")
    ),
    [VatNatureType.N6_5]: sntTranslate(
      marker("Inversione contabile - telefoni cellulari")
    ),
    [VatNatureType.N6_6]: sntTranslate(
      marker("Inversione contabile - cessione di prodotti elettronici")
    ),
    [VatNatureType.N6_7]: sntTranslate(
      marker(
        "Inversione contabile - prestazioni comparto edile e settori connessi"
      )
    ),
    [VatNatureType.N6_8]: sntTranslate(
      marker("Inversione contabile - operazioni settore energetico")
    ),
    [VatNatureType.N6_9]: sntTranslate(
      marker("Inversione contabile - altri casi")
    ),
    [VatNatureType.N7]: sntTranslate(
      marker(
        "IVA assolta in altro stato UE (prestazione di servizi di telecomunicazioni, tele-radiodiffusione ed elettronici ex art. 7-octies lett. a, b, art. 74-sexies DPR 633/72)"
      )
    )
  };
};
